import * as React from 'react'
import { Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { CompanyT } from '../../../types/Company'
import NumberFormatValidate from '../../../components/NumberFormatValidate'

import config from '../../../constants/config'
import { stateFromAddress } from '../../../utils/stateFromAddress'
import { copyObject } from '../../../utils'
import { IAppState } from '../../../redux/reducers'
import GoogleMapAutoComplete from '../../../components/MapBoxAutoComplete/GoogleMapAutoComplete'


interface ColoradoProps {
    company: CompanyT
    // stateMeta: any
    stateTitle: string
    updateStateMeta(value: any): void
}
interface StateMetaColoradoT {
    pucNumber: number
    pucAddress: string
    samePrimaryPuc: boolean
}
const initStateMeta: StateMetaColoradoT = {
    pucNumber: null,
    pucAddress: '',
    samePrimaryPuc: true,
}



const Colorado: React.FunctionComponent<ColoradoProps> = ({ company, stateTitle, updateStateMeta }): JSX.Element => {
    const auth = useSelector((state:IAppState) => state.auth)
    const [dirty, setDirty] = React.useState(null)
    const [samePrimaryPuc, setSamePrimaryPuc] = React.useState(true)
    const [stateMetaColorado, setStateMetaColorado] = React.useState(initStateMeta);

    React.useEffect(() => {
        if (company.stateMeta && company.stateMeta.Colorado) {
            setStateMetaColorado({ ...stateMetaColorado, ...company.stateMeta.Colorado })
        }
    }, [company.stateMeta])


    const updateStateMetaColorado = (key: string, value: any): void => {
        let cloneValues = copyObject(stateMetaColorado)
        cloneValues[key] = value
        setStateMetaColorado(cloneValues)
        updateStateMeta(cloneValues)
        //updateCompany(copyObject(cloneCompany))
    }
    return (
        <div>
            <h3>{stateTitle}</h3>
            <Form.Label>PUC Mover License</Form.Label>
            <NumberFormatValidate
                customInput={Form.Control}
                className="input-material"
                type="text"
                defaultValue={`${stateMetaColorado.pucNumber}`}
                value={`${stateMetaColorado.pucNumber}`}
                onValueChange={(values) => {
                    const { formattedValue, value, floatValue } = values;
                    if (floatValue != stateMetaColorado.pucNumber) {
                        updateStateMetaColorado('pucNumber', floatValue)
                    }
                }}
                mask="_" />
            <Form.Group controlId="formBasicCheckbox">
                <Form.Check
                    type="checkbox"
                    checked={stateMetaColorado.samePrimaryPuc}
                    onChange={() => {
                        updateStateMetaColorado('samePrimaryPuc', !stateMetaColorado.samePrimaryPuc)

                    }}
                    label="Mailing Address on file with PUC same as Primary Address?" />
                {!stateMetaColorado.samePrimaryPuc &&
                    <GoogleMapAutoComplete
                        idAddresss="pucAddress"
                        className='input-material'
                        apiKey={config.keyMap}
                        onChangeText={text => { }}
                        onPress={async location => {
                            updateStateMetaColorado('pucAddress', location.verbose_address)
                            // location.verbose_address
                        }}
                        placeholder=''
                        textValue={stateMetaColorado.pucAddress} />
                }
            </Form.Group>
        </div>
    )
}

export default Colorado